export default "__VITE_ASSET__a05ca504__"